import { Link } from 'react-router-dom';
import Header from '../../components/layout/Header/Header';
import Footer from '../../components/layout/Footer/Footer';
import Seo from '../../components/utils/Seo';
import './NotFound.css';

export default function NotFound() {
  return (
    <div className="notfound-page">
      <Seo title="Page Not Found" description="The page you were looking for could not be found." />
      <Header />
      <main className="notfound-main">
        <p className="eyebrow">404</p>
        <h1 className="notfound-main__title">
          This page isn’t <em>here</em>.
        </h1>
        <p className="notfound-main__body">
          The page you were looking for may have moved or no longer exists.
        </p>
        <div className="notfound-main__actions">
          <Link to="/" className="btn btn--dark">Back to Home</Link>
          <Link to="/projects" className="btn btn--outline">View Projects</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
